import { AppDisplay } from '@ui/applications';
import { AppStatusIndicator } from './AppStatusIndicator';
import { ColumnType } from 'antd/es/table';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import React from 'react';

import { DataSecurityAppActiveStatus, DataSecurityAppActiveStatusType } from '@sonar-software/sonar-core';

type ColumnDefinition = ColumnType<DataSecurityAppActiveStatus>;

export const appColumn: ColumnDefinition = {
	dataIndex: 'applicationId',
	key: 'applicationId',
	render: (applicationId: number, record: DataSecurityAppActiveStatus) =>
		<a
			href={ record.statusPageUrl }
			target='_blank'>
			<AppDisplay
				appId={ applicationId }
				appLabel={ record.applicationLabel }
				appName={ record.applicationName } />
		</a>,
	title: COPY_SPECIFIC.APPLICATION,
	width: 170
};

export const statusColumn = (sorter = false): ColumnDefinition => ({
	dataIndex: 'status',
	key: 'status',
	render: (status: DataSecurityAppActiveStatusType) => <AppStatusIndicator statusType={ status } />,
	sorter,
	title: COPY_SPECIFIC.STATUS,
	width: 125
});

export function getColumns(showSort?: boolean): Array<ColumnDefinition> {
	return [
		appColumn,
		{ key: 'spacer' },
		statusColumn(showSort)
	];
}
